export default {
  list: "lijst",
  update: "detail",
  create: "aanmaken",
}
